import { Component } from '@angular/core';
import { SpThemingService } from 'src/app/services/sp-theming/sp-theming.service';
import { ImageType } from '../sp-page-error/sp-page-error.component';
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sp-page-user-blocked',
  templateUrl: './sp-page-user-blocked.component.html'
})
export class SpPageUserBlockedComponent {
  protected readonly ImageType = ImageType;
  protected blockedReason: string = 'Your account has been blocked by administrators';

  constructor(
    private _spTheming: SpThemingService,
    private sessionProvider: SessionProviderService,
    private route: ActivatedRoute
  ) {
    this._spTheming.setSpThemeName('dashboard-default');
    this.route.queryParamMap.subscribe(params => {
      this.blockedReason = params.get('reason') || this.blockedReason;
    });
  }

  async onButtonClick() {
    await this.sessionProvider.logout();
  }
}
